<input
  pInputText
  [id]="ctrlUUID"
  [placeholder]="formField?.placeholder || ''"
  [formControl]="ctrl"
  [minlength]="formField.minLength === undefined ? null : formField.minLength"
  [maxlength]="formField.maxLength === undefined ? null : formField.maxLength"
  [autocomplete]="ctrlUUID"
  [readonly]="formField?.readonly"
  (keypress)="checkOnlyDigits($event)"
/>
